import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { Activity, LayoutDashboard, Eye, TrendingUp } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const icons = [Activity, LayoutDashboard, Eye, TrendingUp];

export const ValueProposition = () => {
  const { language } = useLanguage();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section 
      ref={ref}
      className="py-24 md:py-32 bg-white dark:bg-slate-900 theme-transition"
      data-testid="value-proposition-section"
    >
      <div className="section-container">
        {/* Section Header */}
        <div className={`text-center mb-16 ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}>
          <h2 className="section-title mb-4" data-testid="value-title">
            {translations.value.title[language]}
          </h2>
          <p className="section-subtitle mx-auto">
            {translations.value.subtitle[language]}
          </p>
        </div>

        {/* Value Cards - Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {translations.value.items.map((item, index) => {
            const Icon = icons[index];
            const isLarge = index === 0 || index === 3;
            
            return (
              <div
                key={index}
                className={`product-card card-hover group ${isLarge ? 'md:row-span-1' : ''} ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}
                style={{ animationDelay: `${index * 0.1}s` }}
                data-testid={`value-card-${index}`}
              >
                <div className="flex flex-col h-full">
                  <div className="feature-icon mb-4 group-hover:scale-110 transition-transform">
                    <Icon className="w-6 h-6" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-2">
                    {item.title[language]}
                  </h3>
                  <p className="text-slate-600 dark:text-slate-400">
                    {item.description[language]}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
